// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DDvG","newExpiryDate":"styles_newExpiryDate__2KbOg","footer":"styles_footer__3WP7M"};